import { contactMatches, formatAddress, type Contact } from "@roof-hawk/core";
import { useState } from "react";

import { t, tn } from "../../i18n";

/** "Returning customer? Search first" — the top of the New Lead modal. */
export function FindCustomer({
  contacts,
  jobCountFor,
  onPick,
}: {
  contacts: readonly Contact[];
  jobCountFor: (contactId: string) => number;
  onPick: (contact: Contact) => void;
}) {
  const [query, setQuery] = useState("");
  const [showDrop, setShowDrop] = useState(false);
  const hits =
    query.trim().length >= 2
      ? contacts.filter((c) => contactMatches(c, query)).slice(0, 6)
      : [];

  return (
    <div className="field full" style={{ marginBottom: 14 }}>
      <label>{t("Returning customer? Search first")}</label>
      <span style={{ position: "relative", display: "block" }}>
        <input
          placeholder={t("Search existing customers by name, phone, or email…")}
          autoComplete="off"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setShowDrop(true);
          }}
          onBlur={() => setTimeout(() => setShowDrop(false), 200)}
        />
        {showDrop && hits.length > 0 && (
          <div className="ac-drop">
            {hits.map((hit) => (
              <div
                key={hit.id}
                className="ac-item"
                onMouseDown={() => onPick(hit)}
              >
                <div className="an">{hit.full_name}</div>
                <div className="aa">
                  {formatAddress(hit)} ·{" "}
                  {tn(jobCountFor(hit.id), "1 job", "{n} jobs")}
                </div>
              </div>
            ))}
          </div>
        )}
      </span>
    </div>
  );
}
